import script from "./TransferOther.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferOther.vue?vue&type=script&setup=true&lang=js"

import "./TransferOther.vue?vue&type=style&index=0&id=b99c69fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b99c69fe"]])

export default __exports__